<template>
  <div class="root">
    <div class="order-status">
      <div class="status-image">
        <img src="@/assets/checkout/check.svg" width="74" height="74" />
      </div>
      <div class="status-message">
        <p>PRE-ORDER THÀNH CÔNG</p>
        <p>FLORENGE {{ selectedVariant.name }}</p>
      </div>
    </div>
    <div class="notice">
      Thông tin cụ thể về đơn hàng đã được gửi vào e-mail của bạn. Curnon sẽ
      liên lạc để xác nhận trong thời gian sớm nhất.
    </div>
    <div class="customer-info">
      <div class="heading">THÔNG TIN KHÁCH HÀNG</div>
      <div class="info">
        {{ values.name }}
      </div>
      <div class="info">
        {{ values.address }}
      </div>
      <div class="info">
        {{ values.email }}
      </div>
      <div class="info">
        {{ values.phone }}
      </div>
    </div>
    <router-link tag="button" to="/" class="cta-btn"
      >TIẾP TỤC MUA SẮM</router-link
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "successCheckout",
  props: ["values"],
  computed: {
    ...mapGetters({
      selectedVariant: "selectedVariant",
    }),
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.root {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .order-status {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 16px;
    .status-image {
      margin-right: 20px;
    }
    .status-message {
      font-family: "SVN-Gotham", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      /* or 137% */

      letter-spacing: 0.03em;

      color: #000000;
      text-transform: uppercase;
      p {
        margin: 0;
      }
    }
  }
  .notice {
    padding: 16px;
    /* margin-top: 16px; */
    font-family: "SVN-Gotham", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 22px;
    /* or 137% */

    display: flex;
    align-items: center;

    color: #000000;
  }
  .customer-info {
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    padding: 16px;
    margin: 16px;
    .heading {
      font-family: "SVN-Gotham", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      /* identical to box height, or 100% */

      display: flex;
      align-items: center;
      letter-spacing: 0.03em;

      color: #000000;
      margin-bottom: 16px;
    }
    .info {
      font-family: "SVN-Gotham", sans-serif;

      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 22px;
      /* or 137% */

      letter-spacing: 0.03em;

      color: rgba(0, 0, 0, 0.6);
    }
  }
  .cta-btn {
    background: #D35C34;
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 48px;
    margin-bottom: 48px;
    font-family: "SVN-Gotham", sans-serif;

    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */

    text-align: center;
    letter-spacing: 0.03em;
    border: none;
    color: #ffffff;
    padding: 26px;
    cursor: pointer;
  }
}
@media (min-width: 1024px) {
  .root {
    padding: 16px;
  }
}
</style>